module.exports = __webpack_public_path__ + "img/img_one_page2.3a9ac5f6.jpg";